import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../components/bannerfrom";
import { Link } from "gatsby";

function Banner(props) {
  return (
    <div className="services_location_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="San Diego">
                <h1>#1 Mobile App Development Company in San Diego</h1>
              </div>
              <p className="main_para">
                Set your business for operational success with our custom mobile
                app development services in San Diego. TekRevol is a top-rated
                mobile app development company in San Diego helping
                entrepreneurs, tech startups and opportunists, SMBs, and
                enterprise-grade corporations take a step ahead with technology.
                Claim competitive advantage while working for a company that
                values business delivery.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                {" "}
                Let’s Get Started
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
